import React from 'react';
import PropTypes from 'prop-types';

export default function IconPersonalCard({ className, style }) {
  return (
    <svg
      className={className}
      fill="none"
      height="18"
      style={style}
      viewBox="0 0 18 18"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M3 3C2.17157 3 1.5 3.67157 1.5 4.5V13.5C1.5 14.3284 2.17157 15 3 15H15C15.8284 15 16.5 14.3284 16.5 13.5V4.5C16.5 3.67157 15.8284 3 15 3H3ZM3.75 4.5C3.33579 4.5 3 4.83578 3 5.24999C3 5.66421 3.33579 5.99999 3.75 5.99999H6C6.41421 5.99999 6.75 5.66421 6.75 5.24999C6.75 4.83578 6.41421 4.5 6 4.5H3.75ZM13.5974 6.74999C13.5974 7.99263 12.5465 8.99999 11.2501 8.99999C9.95364 8.99999 8.90269 7.99263 8.90269 6.74999C8.90269 5.50735 9.95364 4.5 11.2501 4.5C12.5465 4.5 13.5974 5.50735 13.5974 6.74999ZM8.00384 11.2754C8.37072 10.4418 9.22278 9.89998 10.1666 9.89999L12.3334 9.9C13.2772 9.9 14.1293 10.4419 14.4962 11.2754L14.9252 12.2501C15.1863 12.8434 14.7319 13.5 14.0601 13.5H8.43994C7.76814 13.5 7.3137 12.8434 7.57483 12.2501L8.00384 11.2754ZM3 8.24999C3 7.83578 3.33579 7.49999 3.75 7.49999H6C6.41421 7.49999 6.75 7.83578 6.75 8.24999C6.75 8.6642 6.41421 8.99999 6 8.99999H3.75C3.33579 8.99999 3 8.6642 3 8.24999Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

IconPersonalCard.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};
